export default __webpack_public_path__ + "static/media/backgroundImg.c95b87a2.png";